const dataTableFilters = {
  state: {
    filters: {}
  },
  mutations: {
    setFilter(state, { key, value }) {
      state.filters[key] = value;
    },
    resetFilter(state) {
      state.filters = {};
    }
  },
  actions: {
    resetContext(context) {
      context.commit('resetFilter');
    }
  },
  namespaced: true
};

export default dataTableFilters;
